var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsAttach = function SvgInterfaceActionsAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C8.803 1 7 2.803 7 5v12.5c0 3.026 2.474 5.5 5.5 5.5s5.5-2.474 5.5-5.5V6h-2v11.5c0 1.944-1.556 3.5-3.5 3.5A3.486 3.486 0 0 1 9 17.5V5c0-1.117.883-2 2-2s2 .883 2 2v10.5c0 .287-.213.5-.5.5a.487.487 0 0 1-.5-.5V6h-2v9.5c0 1.37 1.13 2.5 2.5 2.5s2.5-1.13 2.5-2.5V5c0-2.197-1.803-4-4-4"
  })));
};
export default SvgInterfaceActionsAttach;